import PhotoCamera from "@mui/icons-material/PhotoCamera";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import React, { useContext, useEffect, useState } from "react";
import { saveProfile } from "../../services/PersonalService";
import { RootStoreContext } from "../../store";
const Input = styled("input")({
  display: "none",
});

export default function UploadButtons() {
  const { PersonalStore } = useContext(RootStoreContext);
  const { profile_picture, updateData } = PersonalStore;
  const [fileUrl, setFileUrl] = useState(profile_picture);

  useEffect(() => {
    updateData("profile_picture", fileUrl);
    saveProfile({ profile_picture: fileUrl });
  }, [fileUrl]);

  const handleFileUpload = (e) => {
    const reader = new FileReader();
    const file = e.target.files[0];
    reader.onloadend = () => {
      setFileUrl(reader.result);
    };
    if (file) reader.readAsDataURL(file);
  };

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <form>
        <label htmlFor="icon-button-file">
          <Input
            accept="image/*"
            id="icon-button-file"
            type="file"
            onChange={handleFileUpload}
          />
          <IconButton
            color="default"
            aria-label="upload picture"
            component="span"
          >
            <PhotoCamera />
          </IconButton>
        </label>
      </form>
    </Stack>
  );
}
